<div>
    <a class="buy_now" [routerLink]="['/shop']">
      <span>Buy Now</span>
    </a>
  </div>